import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../nucleo/autorizacion/guardian.js';
import { rutaRaiz } from './raiz.js';

/**
 * Grupo de la contadora. Se exige `utilidad.ver`, que es nivel 3 en la matriz: el
 * operario y el jefe de operarios no la tienen, y esa es la restricción estructural de
 * la feature 2. El administrador también la tiene, y entra: es su trabajo poder revisar
 * lo que hace la contadora.
 */
export const rutaContabilidad = createRoute({
  getParentRoute: () => rutaRaiz,
  id: '_contabilidad',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'utilidad.ver', nivel: 3 }) }),
  // El proveedor de consultas llega a pedido: la raiz viaja en el fragmento de entrada y
  // la pantalla de ingreso no usa react-query. Ver rutas/consultas.tsx.
  component: lazyRouteComponent(() => import('./consultas.js'), 'ProveedorConsultas'),
});
